import BaseDropSelection from "%/dynamic-component-editor/classes/base-drop-selection";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import { relatedComponentNameForDef } from "%/dynamic-component-editor/helpers/host-bound-component";
import { suggestedStandardComponentId } from "%/dynamic-component-editor/helpers/standard-component-suggestion.mjs";
import { STANDARD_COMPONENTS } from "%/dynamic-component-editor/classes/standard-surface-seeder";

export const LINKED_COMPONENT_ELEMENT_TYPE = "DynamicComponentElement";

export default class LinkedComponentSelection extends BaseDropSelection {
  static optionKey = ReferencedComponentId.optionKey;
  static modalTitle = "Select Component";
  static promptText = "Select the component this element renders.";
  static rowLabel = "Linked Component";
  static placeholder = "Select a component";
  static createItemLabel = "Create a new component";
  static defaultNewItemName = "New Component";
  static createPlaceholder = "Name your new component";
  static pickExistingLabel = "Choose an existing component instead";

  // XXX: A HINT, never a binding. An element's relatedComponents used to bind it
  // XXX: silently at drop time, which made a rename repoint the element and made
  // XXX: two same-named components a coin flip. The author picks; the name only
  // XXX: tells them where to look.
  static promptTextFor(elementDef, elementType = "") {
    const suggested = relatedComponentNameForDef(elementDef, elementType);
    if (!suggested) {
      return this.promptText;
    }
    return `${this.promptText} You are probably looking for the "${suggested}" component.`;
  }

  static suggestedValues(store, elementDef, elementType = "") {
    const componentId = suggestedStandardComponentId(
      relatedComponentNameForDef(elementDef, elementType),
      STANDARD_COMPONENTS,
      store.referencedComponentCandidates,
    );
    return componentId ? { [this.optionKey]: componentId } : {};
  }

  static candidates(store) {
    return store.referencedComponentCandidates
        .map(candidate => ({ label: candidate.name, value: candidate.id }));
  }

  static createCandidate(store, name) {
    return store.createComponentForDropSelection(name);
  }
}

BaseDropSelection.register(LINKED_COMPONENT_ELEMENT_TYPE, LinkedComponentSelection);
BaseDropSelection.registerComponentLinkedFallback(LinkedComponentSelection);
